import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class RetrieveCookieService {
	private readonly cookieKey: string = `embrace_retriever`;
	private readonly domain: string = `.embracepetinsurance.com`;

	constructor() {
	}

	private get maxAge(): number {
		const numberOfYears = 2;
		const days = 365;
		const hours = 24;
		const minutes = 60;
		const seconds = 60;

		return numberOfYears * days * hours * minutes * seconds;
	}

	public getRetrieveCookie(): string {
		return document.cookie
			.split(`;`)
			.map(cookie => cookie.trim())
			.find(entry => entry.includes(this.cookieKey))
			?.split(`=`)[1] ?? ``;
	}

	public update(contactId: string): void {
		document.cookie = /localhost/.test(location.host)
			? `${this.cookieKey}=${contactId};samesite=lax;max-age=${this.maxAge}`
			: `${this.cookieKey}=${contactId};samesite=lax;max-age=${this.maxAge};domain=${this.domain}`;
	}

	public delete(): void {
		document.cookie = /localhost/.test(location.host)
			? `${this.cookieKey}=${JSON.stringify('')};expires=Thu, 01 Jan 1970 00:00:00 GMT`
			: `${this.cookieKey}=${JSON.stringify('')};expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${this.domain}`;
	}
}
